<template>
	<a-modal :title="type == 'add' ? `${props.title}` : `编辑电价策略模板`" :open="props.visible" width="962px" @ok="okClick" @cancel="cancel">
		<a-form ref="formRef" :model="formState" name="basic" style="margin-top: 12px">
			<a-row v-if="type == 'select'" class="top-row">
				<a-form-item style="width: 100%" label="选择模板">
					<div class="template">
						<a-select v-model:value="templateId" style="width: 282px" placeholder="请选择模版">
							<a-select-option v-for="(item, index) in templateList" :key="index" :value="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>

						<a-button :disabled="!templateId" type="primary" class="fromTemp" @click="fromTemplate">从模版带入</a-button>
					</div>
				</a-form-item>
				<a-button @click="resetDefault">恢复默认值</a-button>
			</a-row>
			<a-row v-if="type == 'add' || type == 'edit'">
				<a-form-item label="模板名称" name="name" :rules="requireRule">
					<a-input v-model:value="formState.name" placeholder="请输入" style="width: 300px" :maxlength="50"></a-input>
				</a-form-item>
			</a-row>
			<a-flex gap="middle" class="flex-row">
				<a-form-item label="尖" name="sharp" :rules="requireRule" class="noFlex">
					<a-input placeholder="请输入" v-model:value="formState.sharp" @input="inputChange('sharp', 9)" @blur="blur('sharp')">
						<template #suffix>元/kWh</template>
					</a-input>
				</a-form-item>
				<a-form-item label="峰" name="peak" :rules="requireRule" class="noFlex">
					<a-input placeholder="请输入" v-model:value="formState.peak" @input="inputChange('peak', 9)" @blur="blur('peak')">
						<template #suffix>元/kWh</template>
					</a-input>
				</a-form-item>
				<a-form-item label="平" name="flat" :rules="requireRule" class="noFlex">
					<a-input placeholder="请输入" v-model:value="formState.flat" @input="inputChange('flat', 9)" @blur="blur('flat')">
						<template #suffix>元/kWh</template>
					</a-input>
				</a-form-item>
				<a-form-item label="谷" name="valley" :rules="requireRule" class="noFlex">
					<a-input placeholder="请输入" v-model:value="formState.valley" @input="inputChange('valley', 9)" @blur="blur('valley')">
						<template #suffix>元/kWh</template>
					</a-input>
				</a-form-item>
				<a-form-item label="深谷" name="ravine" :rules="requireRule" class="noFlex">
					<a-input placeholder="请输入" v-model:value="formState.ravine" @input="inputChange('ravine', 9)" @blur="blur('ravine')">
						<template #suffix>元/kWh</template>
					</a-input>
				</a-form-item>
			</a-flex>
		</a-form>

		<a-table class="xftg-temp-table beautify_scroll" :columns="columns" :data-source="tableList" :pagination="false" :scroll="{y: 365}" bordered>
			<template #bodyCell="{column, record, index}">
				<template v-if="column.key === 'start'">
					<a-time-picker
						style="width: 100%"
						v-model:value="record.start"
						format="HH:mm"
						:disabled-time="
							() => {
								return disabledTime(record, 'start', index);
							}
						"
						:hideDisabledOptions="true"
						:showNow="false"
						:allowClear="false"
						value-format="HH:mm"
						@change="timeChange($event, record, 0, index)"
					/>
				</template>
				<template v-if="column.key === 'end'">
					<a-time-picker
						style="width: 100%"
						v-model:value="record.end"
						format="HH:mm"
						:disabled-time="
							() => {
								return disabledTime(record, 'end', index);
							}
						"
						:hideDisabledOptions="true"
						:showNow="false"
						:allowClear="false"
						value-format="HH:mm"
						@change="timeChange($event, record, 1, index)"
					/>
				</template>
				<template v-if="column.key === 'type'">
					<a-select style="width: 100%" placeholder="请选择" v-model:value="record.type">
						<a-select-option v-for="type of types" :key="type.value" :value="type.value">
							{{ type.label }}
						</a-select-option>
					</a-select>
				</template>
			</template>
		</a-table>

		<div class="btns">
			<a-button @click="addRule">
				<template #icon>
					<PlusOutlined />
				</template>
			</a-button>
			<a-button @click="removeRule">
				<template #icon>
					<MinusOutlined />
				</template>
			</a-button>
		</div>
	</a-modal>
</template>

<script setup>
import {reactive, ref, defineEmits, watch, onMounted} from "vue";
import {message} from "ant-design-vue";
import moment from "moment";
import {PlusOutlined, MinusOutlined} from "@ant-design/icons-vue";

// api
import {editElecPriceStrategyTemplatePage, getElecPriceStrategyTemplatePageList} from "@/api/elecPriceStrategyTemplate.js";

const props = defineProps({
	title: {
		type: String,
		default: () => {
			return "";
		},
	},
	visible: {
		type: Boolean,
		default: () => {
			return false;
		},
	},
	clickIndex: {
		type: Number,
		default: () => {
			return null;
		},
	},
	defaultStrategyData: {
		type: Array,
		default: () => {
			return [];
		},
	},
	type: {
		type: String,
		default: () => {
			return "";
		},
	},
	modalData: {
		type: Object,
		default: () => {
			return null;
		},
	},
});

const formRef = ref();
const emit = defineEmits(["visibleChange", "regetTable", "rebackData"]);

const types = [
	{
		label: "充电",
		value: 1,
	},
	{
		label: "静置",
		value: 0,
	},
	{
		label: "放电",
		value: -1,
	},
];
// 不为空校验
const requireRule = [{required: true, message: "请输入"}];

const columns = [
	{
		title: "开始时间",
		key: "start",
		dataIndex: "start",
		width: "33%",
	},
	{
		title: "结束时间",
		key: "end",
		dataIndex: "end",
		width: "33%",
	},
	{
		title: "充放策略",
		key: "type",
		dataIndex: "type",
	},
];

const tableList = ref([]);

const formState = reactive({
	name: "",
	sharp: "",
	peak: "",
	flat: "",
	valley: "",
	ravine: "",
});

// 模板数据
const templateList = ref([]);
const templateId = ref(null);

// 获取模板下拉数据
const getTemplateLists = () => {
	getElecPriceStrategyTemplatePageList().then(res => {
		console.log("list:", res);
		templateList.value = res || [];
		// if (res && res.length > 0) {
		// 	templateId.value = res[0].id;
		// }
	});
};

// 从模板带入
const fromTemplate = () => {
	console.log(templateList.value);
	console.log(templateId.value);
	let row = templateList.value.filter(tem => tem.id == templateId.value);

	if (row.length > 0) {
		const {name, paramInfo} = row[0];
		if (paramInfo) {
			const {sharp, peak, flat, valley, ravine, strategyInfo} = paramInfo;
			formState.name = name;
			formState.sharp = sharp;
			formState.peak = peak;
			formState.flat = flat;
			formState.valley = valley;
			formState.ravine = ravine;

			tableList.value = strategyInfo;
		}
	}
	console.log(row);
};

// 确认
const okClick = () => {
	// 校验表单
	formRef.value.validate().then(values => {
		console.log(`values:`, values);
		// 校验表格时间是否符合规范
		const checked = validateData(tableList.value);
		if (checked.resule) {
			const {name, sharp, peak, flat, valley, ravine} = values;
			const send = {
				id: ["edit", "select"].includes(props.type) ? props.modalData.id : null,
				name,
				paramInfo: {
					sharp,
					peak,
					flat,
					valley,
					ravine,
					strategyInfo: tableList.value,
				},
			};
			if (props.type == "add" || props.type == "edit") {
				editElecPriceStrategyTemplatePage(send).then(res => {
					console.log(res);
					if (res) {
						message.success(props.type == "add" ? "模板新建成功" : "模板编辑成功");
						emit("regetTable");
					}
				});
			}

			if (props.type == "select") {
				// 不发送请求，而是将数据返回渲染
				emit("rebackData", {
					...values,
					strategyInfo: tableList.value,
				});
			}
		} else {
			message.info(checked.message);
		}
	});
};

// 校验表格
const validateData = arr => {
	if (arr.length == 0) {
		return {
			resule: false,
			message: "请输入策略时段信息",
		};
	}
	// 检查每个对象中的start时间是否小于等于end时间
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].start >= arr[i].end) {
			console.log("触发了");
			return {
				result: false,
				message: `第 ${i + 1} 行数据的结束时间不能小于等于开始时间`,
			};
		}
	}

	// 检查数据是否按照时间顺序排列
	for (let i = 0; i < arr.length - 1; i++) {
		if (arr[i].end !== arr[i + 1].start) {
			return {
				resule: false,
				message: "时间不连贯，请检查",
			};
		}
	}

	// 检查数据的起始时间是否为"00:00"，结尾时间是否为"23:59"
	if (arr[0].start !== "00:00" || arr[arr.length - 1].end !== "23:59") {
		return {
			resule: false,
			message: "起始必须为00:00，结尾必须为23:59",
		};
	}

	return {
		resule: true,
	};
};

// 关闭弹窗
const cancel = () => {
	emit("visibleChange", false);
};

// 重置
const resetDefault = () => {
	tableList.value = [];
	if (props.defaultStrategyData[props.clickIndex]) {
		const {name, sharp, peak, flat, valley, ravine, strategyInfo} = props.defaultStrategyData[props.clickIndex];

		formState.name = name;
		formState.sharp = sharp;
		formState.peak = peak;
		formState.flat = flat;
		formState.valley = valley;
		formState.ravine = ravine;

		tableList.value = JSON.parse(JSON.stringify(strategyInfo));
	}
	console.log(props.defaultStrategyData[props.clickIndex]);
};

// 添加模板规则
const addRule = () => {
	let end = "",
		start = "";
	if (!tableList.value.length) {
		end = "23:59";
		start = "00:00";
	} else {
		const last = tableList.value.at(-1);
		end = "23:59";
		start = last.end;
	}
	tableList.value.push({
		end,
		start,
		type: 0,
	});
};

// 删除模板规则
const removeRule = () => {
	tableList.value.pop();
};

// 设置不可选时间
const disabledTime = (record, key, index) => {
	return {
		disabledMinutes: h => {
			const result = [];
			for (let i = 0; i < 60; i++) {
				if (i % 15 != 0) {
					// 不能被15整除的push进去
					if (h == 23) {
						if (i != 59) {
							result.push(i);
						}
					} else {
						result.push(i);
					}
				}
			}

			// if (h != 23) {
			// 	record[key] = `${h}:00`;
			// }
			return result;
		},
	};
};

// 模板时间变更
const timeChange = (event, record, tag, index) => {
	console.log("触发了");
	if (!event) return;
	// 开始时间
	console.log(event);
	console.log("index", index);
	if (!event.startsWith("23") && event.endsWith("59")) {
		message.info("除23点外不可以59结尾");
		let copy = JSON.parse(JSON.stringify(tableList.value));
		let arr = event.split(":");
		copy[index]["end"] = [arr[0], "00"].join(":");
		tableList.value = copy;
	}
	if (!tag) {
		console.log("111111");
		if (tableList.value.length !== 1) {
			// 当前行开始时间 不得早于 上一行结束时间
			let isFlag = false;
			for (let item of tableList.value) {
				if (item.id === record.id) break;
				let diff = moment(event).diff(moment(item.end, "HH:mm"));
				if (diff < 0) {
					isFlag = true;
					break;
				}
			}
			// 触发
			if (isFlag) {
				message.info("不能和其他行时间冲突");
			} else {
				rowTimeDiff(record, tag, event);
			}
		} else {
			console.log("222222");
			if (record.start != "00:00") {
				message.info("模板起始时间必须为00:00");
				record.start = "00:00";
			}
		}
	} else {
		console.log("33333");
		rowTimeDiff(record, tag, event);
	}
	resetAfterTime(record, tableList.value);

	// 重置后面的时间 避免冲突
	function resetAfterTime(record, list) {
		let flag = false;
		for (let item of list) {
			if (item.start === record.start && item.end === record.end) {
				flag = true;
				continue;
			}
			if (flag) {
				item.start = record.end;
				item.end = record.end;
			}
		}
	}
};
// 修改时间 校验 行内比较时间
const rowTimeDiff = (record, tag, event) => {
	let is_error = false;
	let err_time = null;

	for (let item of tableList.value) {
		if (item.start === record.start) {
			break;
		}
		let is_than = moment(event, "HH:mm").format("x") < moment(item.end, "HH:mm").format("x");
		if (is_than) {
			is_error = true;
			err_time = item.end;
		}
	}
	if (is_error) {
		message.info("不能和前面时间冲突");
		record["start"] = err_time;
		return;
	}
	// 时间戳
	let start = moment(record.start, "HH:mm").format("x"),
		end = moment(record.end, "HH:mm").format("x"),
		current = moment(event, "HH:mm").format("x");
	// 调整开始时间
	if (!tag) {
		if (current > end) {
			record["start"] = event;
			record["end"] = event;
		} else {
			record["start"] = event;
		}
	} else {
		// 调整结束时间
		if (current < start) {
			record["start"] = event;
			record["end"] = event;
		} else {
			record["end"] = event;
		}
	}
};

/* 数据处理 */
// 最多9位小数
let inputChange = props => {
	var isValid = /^\d+(\.\d{0,9})?$/.test(formState[props]);

	if (!isValid) {
		// 如果输入不符合要求，只保留有效的数字部分
		let validValue = formState[props].match(/^\d+(\.\d{0,9})?/);
		formState[props] = validValue ? validValue[0] : "";
	}
};

// 离开时校验最后是否为小数点
let blur = props => {
	if (formState[props].endsWith(".")) {
		formState[props] = formState[props].slice(0, -1);
	}
};

watch(
	() => props.visible,
	newVal => {
		console.log(newVal);
		if (newVal) {
			if (props.modalData && props.type != "add") {
				const copyVal = JSON.parse(JSON.stringify(props.modalData));
				if (props.type == "edit") {
					const {name, paramInfo} = copyVal;
					console.log(paramInfo);
					if (paramInfo) {
						const {sharp, peak, flat, valley, ravine, strategyInfo} = paramInfo;
						formState.name = name;
						formState.sharp = sharp;
						formState.peak = peak;
						formState.flat = flat;
						formState.valley = valley;
						formState.ravine = ravine;

						tableList.value = strategyInfo;
					}
				}

				if (props.type == "select") {
					const {name, sharp, peak, flat, valley, ravine, strategyInfo} = copyVal;

					// 获取模板下拉数据
					getTemplateLists();

					formState.name = name;
					formState.sharp = sharp;
					formState.peak = peak;
					formState.flat = flat;
					formState.valley = valley;
					formState.ravine = ravine;

					tableList.value = strategyInfo;
				}
			}
		} else {
			// 关闭时清空
			console.log("ormRef:", formRef.value);
			formState.name = "";
			formState.sharp = "";
			formState.peak = "";
			formState.flat = "";
			formState.valley = "";
			formState.ravine = "";
			tableList.value = [];
			templateId.value = null;
		}
	},
	{immediate: true, deep: true}
);
</script>

<style lang="less" scoped>
.template {
	display: flex;
	align-items: center;

	position: relative;

	button {
		margin-left: 8px;
	}

	/* .fromTemp {
		position: absolute;
		right: 0;
		top: 50;
		transform: translateY(-50%);
	} */
}

.btns {
	margin-top: 8px;
	button {
		margin-left: 8px;
	}
}
::v-deep .noFlex {
	.ant-row {
		display: block;
	}
}
.top-row {
	display: flex;
	justify-content: space-between;
}
::v-deep .ant-modal .ant-modal-header {
	margin-bottom: 16px !important;
}
::v-deep .ant-form-item {
	margin-bottom: 12px !important;
}

::v-deep .flex-row {
	.ant-form-item-label > label {
		height: 22px !important;
	}
}

::v-deep .ant-table-body {
	overflow-y: auto !important;
	/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	&::-webkit-scrollbar {
		width: 4px; /*滚动条宽度*/
		height: 12px;
	}

	/*定义滚动条轨道 内阴影+圆角*/
	&::-webkit-scrollbar-track {
		background-color: #fff;
	}

	/*定义滑块 内阴影+圆角*/
	&::-webkit-scrollbar-thumb {
		background-color: rgba(63, 79, 116, 0.3);
		border-radius: 4px;
	}
	&::-webkit-scrollbar-corner {
		background-color: #fff;
	}
}
</style>
